/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TargetRadialIcon20Light = forwardRef('TargetRadialIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 7.755a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Zm-1.25 2.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.875 10.005a5.125 5.125 0 1 1 10.25 0 5.125 5.125 0 0 1-10.25 0ZM10 5.88a4.125 4.125 0 1 0 0 8.25 4.125 4.125 0 0 0 0-8.25Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8-7a7 7 0 1 0 0 14 7 7 0 0 0 0-14Z" })));
});
